const initialState = {
    hydrantLists: [],
    hydrantStatusList: [],
    hydrantPermissions: {},
    changedHydrantStatus : [],
    hydrantById: {},
    loadingHydrant: false,
    errorsHydrant: {},
    summary: {}
    };

const hydrantReducer = (state = initialState, action) => {
    switch (action.type) {
        case "GET_HYDRANTLIST_PENDING":
        case "ADD_HYDRANT_PENDING":
        case "UPDATE_HYDRANT_PENDING":
        case "UPDATE_HYDRANT_STATUS_PENDING":
        case "DELETE_HYDRANT_PENDING":
        case "GET_HYDRANTLISTBYID_PENDING":
            return { ...state, loadingHydrant: true };

        case "GET_HYDRANTLIST_FULFILLED":
            return {
                ...state,
                loadingHydrant: false,
                hydrantLists: action.payload,
                hydrantStatusList: action.hydrantStatusList || [],
                hydrantCount: action.count,
                hydrantPermissions:action.permissions,
                summary: action.summary,
            };

        // Pushed directly by the backend via socket whenever fresh MQTT telemetry arrives —
        // no API call involved, just merge the live valve/camera/summary data into state.
        case "HYDRANT_LIVE_STATUS_SOCKET_UPDATE":
            return {
                ...state,
                hydrantStatusList: action.hydrantStatusList || state.hydrantStatusList,
                summary: action.summary || state.summary,
            };

        case "ADD_HYDRANT_FULFILLED":
            return {
                ...state,
                loadingHydrant: false,
                changedHydrantStatus: action.payload,
            };

        case "UPDATE_HYDRANT_FULFILLED":
            return {
                ...state,
                loadingHydrant: false,
                changedHydrantStatus: action.payload,
            };

        case "UPDATE_HYDRANT_STATUS_FULFILLED":
            return {
                ...state,
                loadingHydrant: false,
                changedHydrantStatus: action.payload,
            };

        case "GET_HYDRANTLISTBYID_FULFILLED":
            return {
                ...state,
                loadingHydrant: false,
                hydrantLists: action.payload,
                hydrantById: action.payload
            };

        case "DELETE_HYDRANT_FULFILLED":
            return {
                ...state,
                loadingHydrant: false,
                changedHydrantStatus: action.payload
            };

        case "RESET_DELETE_HYDRANTS_STATUS":
            return {
                ...state,
                loadingHydrant: false,
                changedHydrantStatus: [],
                errorsHydrant:{}
            };

        case "GET_HYDRANTLIST_REJECTED":
        case "ADD_HYDRANT_REJECTED":
        case "UPDATE_HYDRANT_REJECTED":
        case "UPDATE_HYDRANT_STATUS_REJECTED":
        case "DELETE_HYDRANT_REJECTED":
        case "GET_HYDRANTLISTBYID_REJECTED":
            return {
                ...state,
                loadingHydrant: false,
                errorsHydrant: action.payload
            };

        default:
            return state;
    }
}

export default hydrantReducer;
